const theme = {
  colors: {
    primary: "#5e6ff9",
    secondary: "#313f58",
  },
  bgColors: {
    primary: "white",
  },
  shadows: {
    default: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    hover: "#5e6ff9 0px 3px 8px",
  },
  fontSizes: {
    heading0: "2.7rem",
    heading1: "2.6rem",
    heading2: "2rem",
    heading3: "1.3rem !important",
    heading4: "2rem",
    heading5: "15px",
    heading6: "1.7rem",

    paragraph1: "1.25rem",
    paragraph2: "1rem",
    paragraph3: "20px",
    paragraph4: "18px",
    paragraph5: "15px",
  },
};

export default theme;
